module.exports = __webpack_public_path__ + "img/apple.8222c50b.png";